
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getOrdersByTable } from "../ordersThunk";
import { OrdersState } from "../types";
import { CustomError } from "shared/api";

export const getOrdersByTableReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersByTable.pending, state => {
			state.loading = true;
			state.loadingError = ''
		})
		.addCase(getOrdersByTable.fulfilled, (state, action) => {
			state.loading = false;
			const results = action.payload;
		
			if (!results.length) {
				state.ordersByTable = [];
			}
			state.ordersByTable = results;
		
			state.error = null;
		})
		
		.addCase(getOrdersByTable.rejected, (state, action) => {
			state.loading = false;
			state.loadingError = 'Произошла ошибка загрузки данных'
			state.error = action.payload as CustomError;
		})
}